import {
  Monitor, Gauge, ShieldCheck, Wifi, Laptop, Database, HelpCircle, Server, MailCheck,
  Network, Globe, Layers, Gem, Cloud, Code2, Cpu,
} from 'lucide-react';

const ICONS = {
  'Remote Device Troubleshooting': Monitor,
  'Performance and PC Optimization': Gauge,
  'Virus and Spyware Removal': ShieldCheck,
  'WiFi and Network Setup and Configuration': Wifi,
  'New PC Setup and Data Transfer': Laptop,
  'Data Recovery': Database,
  'General Question': HelpCircle,
  'Hardware Deployment': Server,
  'Email & Domain Hardening': MailCheck,
  'Consulting & Architecture': Network,
  'Core Build': Globe,
  'Vector Stack Build': Layers,
  'Quantum Custom': Gem,
  'Managed Web Services': Cloud,
  'Custom Web Services': Code2,
};

export const iconFor = (name) => ICONS[name] || Cpu;

export const slugify = (name) => name.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

export const priceText = (s) => {
  if (s.pricing_label) return s.pricing_label;
  return `$${Number(s.base_price).toLocaleString()}`;
};

export const isConsultService = (s) =>
  s && (s.category === 'web' || s.category === 'managed' || s.name === 'Consulting & Architecture');
